import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'

/**
 * Hook for handling the selection of a team, user, or patient in the agenda calendar
 * @returns The handlers for the selection of a team, user, or patient
 */
export const useAgendaSearchHandlers = () => {
    const {navigateToView} = useAgendaNavigation()
    const {setSearchParams, searchParams} = useAgendaSearchParams()

    // Handle the selection of a team
    const handleTeamSelection = (value: string) => {
        navigateToView('day')
        setSearchParams({
            patientId: value,
            specializationIds: undefined,
            category: 'team',
            subjectIds: undefined
        })
    }

    // Handle the selection of a user
    const handleUserSelection = (userId: string) => {
        if (searchParams.subjectIds && searchParams.subjectIds.length > 0) {
            navigateToView('day')
        }

        setSearchParams({
            patientId: undefined,
            specializationIds: undefined,
            category: 'custom',
            subjectIds:
                searchParams.subjectIds && searchParams.subjectIds.includes(userId)
                    ? searchParams.subjectIds.filter(id => id != userId)
                    : [...(searchParams.subjectIds || []), userId]
        })
    }

    const handlePatientSelection = (patientId: string) => {
        setSearchParams({
            patientId: undefined,
            specializationIds: undefined,
            category: 'custom',
            subjectIds: [patientId]
        })
    }

    const handleHideDomiciliary = (checked: boolean) => {
        setSearchParams({
            ...searchParams,
            hideDomiciliary: checked ? 'true' : undefined
        })
    }

    const handleHideHolidays = (checked: boolean) => {
        setSearchParams({
            ...searchParams,
            hideHolidays: checked ? 'true' : undefined
        })
    }

    return {
        handleTeamSelection,
        handleUserSelection,
        handlePatientSelection,
        handleHideDomiciliary,
        handleHideHolidays
    }
}
